/**
 * Szolgáltatás kártyák — "Tovább olvasom" / "Kevesebb mutatása" toggle
 *
 * Logika:
 *  - Minden .svc-card-on belül a .svc-card__text alapból clamped (5 sor) a CSS-ből.
 *  - Mérjük, hogy a teljes szöveg magassága nagyobb-e mint a clamped magasság.
 *  - Ha igen: megmutatjuk a .svc-card__expand gombot.
 *  - Click: toggle .is-expanded a kártyán + felirat csere + aria-expanded.
 *  - Resize esetén újraméretezés (debounced), mert változhat a sorszám.
 *  - Kártya <a> esetén stopPropagation, hogy ne navigáljon a click.
 */
(function () {
  var cards = document.querySelectorAll('.svc-card');
  if (!cards.length) return;

  function setupCard(card) {
    var textEl   = card.querySelector('.svc-card__text[data-clamp]');
    var expand   = card.querySelector('.svc-card__expand');
    var btn      = card.querySelector('.svc-card__expand-btn');

    if (!textEl || !expand || !btn) return;

    function refresh() {
      var isExpanded = card.classList.contains('is-expanded');
      if (isExpanded) {
        expand.hidden = false;
        return;
      }
      var truncated = textEl.scrollHeight > textEl.clientHeight + 1;
      expand.hidden = !truncated;
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var isExpanded = card.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

      var moreLabel = btn.getAttribute('data-more-label') || 'Tovább olvasom';
      var lessLabel = btn.getAttribute('data-less-label') || 'Kevesebb mutatása';
      btn.textContent = isExpanded ? lessLabel : moreLabel;
    });

    refresh();
    card._svcRefresh = refresh;
  }

  Array.prototype.forEach.call(cards, setupCard);

  /* Resize-on újraellenőrzés (debounced) */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      Array.prototype.forEach.call(cards, function (card) {
        if (typeof card._svcRefresh === 'function') card._svcRefresh();
      });
    }, 150);
  });

  /* Webfont betöltés után újraméretezés (a sorszám változhat) */
  if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(function () {
      Array.prototype.forEach.call(cards, function (card) {
        if (typeof card._svcRefresh === 'function') card._svcRefresh();
      });
    });
  }
})();
